import { useEffect, useState } from "react";

export const useMobileLayout = () => {
  const isMobileLayout = useMedia("(max-width: 1199px)");
  return isMobileLayout;
};

export const useDesktopLayout = () => {
  const isMobileLayout = useMedia("(min-width: 1200px)");
  return isMobileLayout;
};

export const useMilestoneDrawer = () => {
  const shouldUseDrawer = useMedia("(max-width: 1450px)");
  return shouldUseDrawer;
};

//React sensor hook that tracks state of a CSS media query from react-use
export const useMedia = (query, defaultState = false) => {
  const [state, setState] = useState(defaultState);

  useEffect(() => {
    let mounted = true;
    const mql = window.matchMedia(query);
    const onChange = () => {
      if (!mounted) return;
      setState(!!mql.matches);
    };

    mql.addListener(onChange);
    setState(mql.matches);

    return () => {
      mounted = false;
      mql.addEventListener("change", onChange);
    };
  }, [query]);

  return state;
};
